import { getFWDVolCurrencies } from "@/_core/data/api_calls/fwd_vol/getFWDVolCurrencies";
import { getFWDVolCommodities } from "@/_core/data/api_calls/fwd_vol/getFWDVolCommodities";

/**
 * Retrieves forward and volatility data for commodities
 * @param {object} ctx: context variables, must include ctx.currencyNumber and ctx.initCurrencyDate
 * @param {string} asset: asset type string, only currency for the moment
 */
export function getFWDVol(ctx, asset = "currency") {
  if (asset === "currency") {
    return getFWDVolCurrencies(ctx);
  } else if (asset === "commodity") {
    return getFWDVolCommodities(ctx);
  }
}
